// extracted by mini-css-extract-plugin
export default {"CardTile":"CardTile_CardTile__vsiBj","card-img":"CardTile_card-img__AsRxk"};